import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';

@Component({
    selector: 'pf-switch',
    templateUrl: './switch.component.html',
    styleUrls: ['./switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SwitchComponent extends BaseControlComponent {}
